module.exports = __webpack_public_path__ + "img/stock1.562975eb.png";